import { stats } from '@fiverr-private/obs';
import { PREFIX } from './constants';

export const sendGraph = (label) => stats.count(PREFIX, label);
